import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiShoppingCart, FiMenu, FiX } from "react-icons/fi";

const Header = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  // Navigation Links
  const navLinks = [
    { path: "/home", label: "Home" },
    { path: "/products", label: "Products" },
    { path: "/about", label: "About" },
    { path: "/contact", label: "Contact" },
    { path: "/cart", icon: <FiShoppingCart size={24} /> },
    { path: "/shop-later", label: "Shop Later" }
  ];

  return (
    <header className="fixed top-0 left-0 w-full flex justify-between items-center px-6 py-4 bg-black bg-opacity-90 backdrop-blur-lg shadow-lg z-50"
      style={{
        boxShadow: "0 4px 15px rgba(255, 192, 203, 0.4)"
      }}
    >

      {/* Logo */}
      <h1
        className="text-2xl md:text-3xl font-bold text-rose-300 tracking-wider"
        style={{ fontFamily: "'Poppins', sans-serif" }}
      >
        De Vānā Designs
      </h1>

      {/* Mobile Menu Button */}
      <button
        className="text-rose-300 md:hidden"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? <FiX size={28} /> : <FiMenu size={28} />}

      </button>

      {/* Navigation */}
      <nav
        className={`absolute md:relative top-16 md:top-0 right-0 w-full md:w-auto bg-black md:bg-transparent transition-transform duration-300 ease-in-out ${isOpen ? "translate-x-0" : "translate-x-full md:translate-x-0"}`}
      >
        <ul className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-8 items-center md:items-end p-6 md:p-0">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`text-lg px-3 py-1 transition-all duration-300 ease-in-out flex items-center ${location.pathname === link.path ||
                  (link.path === "/products" &&
                    location.pathname.startsWith("/products"))
                  ? "text-rose-300 border-b-2 border-rose-300"
                  : "text-white hover:text-rose-300 hover:border-b-2 hover:border-rose-300"
                  }`}
              >
                {link.icon || link.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
